/**
 * Labstep
 *
 * @module components/ExperimentWorkflow/PostFilter/Pane
 * @desc Filter pane for experiment workflow
 */

import ExperimentWorkflowPostFilterPrimaryList from 'labstep-web/components/ExperimentWorkflow/PostFilter/Primary/List';
import { ExperimentWorkflowPostFilterSignedList } from 'labstep-web/components/ExperimentWorkflow/PostFilter/Signed/List';
import ExperimentWorkflowPostFilterStatusList from 'labstep-web/components/ExperimentWorkflow/PostFilter/Status/List';
import { FilterAssignedToList } from 'labstep-web/components/Filter/AssignedTo/List';
import { FilterCreatedByList } from 'labstep-web/components/Filter/CreatedBy/List';
import { FilterTagList } from 'labstep-web/components/Filter/Tag/List';
import { ExperimentWorkflow } from 'labstep-web/models/experiment-workflow.model';
import type React from 'react';

export const ExperimentWorkflowPostFilterPane: React.FC = () => {
  return (
    <>
      <FilterCreatedByList
        entityName={ExperimentWorkflow.entityName}
        usePostFilter
      />
      <FilterAssignedToList
        entityName={ExperimentWorkflow.entityName}
        usePostFilter
      />
      <FilterTagList
        entityName={ExperimentWorkflow.entityName}
        usePostFilter
      />
    </>
  );
};
